export const STRIPE_M2_OFFLINE_FORWARDING_RECORD_PREFIX =
  'pointcraft.v4.stripe-m2-offline-forward:';

export function isStripeM2OfflineForwardingRecordKey(type: string): boolean {
  return type.startsWith(STRIPE_M2_OFFLINE_FORWARDING_RECORD_PREFIX);
}
